import React, { forwardRef } from 'react';
import { Search as CarbonSearch, SearchProps } from '@carbon/react';

export const Search = forwardRef<HTMLInputElement, SearchProps>(
  (props, ref) => <CarbonSearch ref={ref} {...props} />
);

Search.displayName = 'Search';
